import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SnackbarData } from '../snackbar/snackbar.component';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-workspace-creation-snackbar',
  templateUrl: './workspace-creation-snackbar.component.html',
  styleUrls: ['./workspace-creation-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class WorkspaceCreationSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: WorkspaceCreationSnackbarData,
    public snackBarRef: MatSnackBarRef<WorkspaceCreationSnackbarComponent>,
    public router: Router,
  ) {}

  close() {
    this.snackBarRef.dismiss();
  }

  viewWorkspace() {
    this.router.navigate(['/workspaces', this.data.uniqueId]);
  }
}

export interface WorkspaceCreationSnackbarData extends SnackbarData {
  uniqueId: string;
}
